import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

function UserProfileEditModal() {
  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          {/* <Grid item xs={12} md={12}>
            <div className="modalInput">
              <SearchIcon />
              <input className="modalInputSt" placeholder="Search here" />
            </div>
          </Grid> */}
          <Grid item xs={12} md={6}>
            <input className="inputSt" placeholder="User Name" />
          </Grid>
          <Grid item xs={12} md={6}>
            <input className="inputSt" placeholder="Phone Number" />
          </Grid>
          <Grid item xs={12} md={6}>
            <input className="inputSt" placeholder="Email Id" />
          </Grid>
          <Grid item xs={12} md={6}>
            <input className="inputSt" placeholder="Occupation" />
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="fileUpInModal">
              <UploadIcon />
              <input
                type="file"
                className="inputSt"
                placeholder="Vehicle Number"
              />
              <span>Upload Documents</span>
            </div>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain">
              <Button className="modalMainBt" onClick={addCommitee}>
                Save
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
              <h4>Success !</h4>
              <p>Saved Profile successfully</p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default UserProfileEditModal;
